import { Col } from "react-bootstrap";
import "./style.css";

interface IProps {
  lg: number;
  children: any;
  className?: string;
}

const SectionBorder = ({ lg, children, className }: IProps) => {
  return (
    <Col md={12} lg={lg} className="mb-3">
      <div className={`form-section-border${className ? ` ${className}` : ""}`}>{children}</div>
    </Col>
  );
};

export default SectionBorder;
